import { Col } from "react-bootstrap";
import TeamMemberIndicatorsList from "./TeamMemberIndicatorsList";
import { useTranslation } from "react-i18next";
import "./TeamMember.css";

function TeamMember({ id, name, indicators, language }) {
  const { t } = useTranslation();

  return (
    <Col key={id} id={id} className="team-member-card mb-4">
      <Col>
        <h5>{name}</h5>
      </Col>
      <Col>
        <TeamMemberIndicatorsList indicators={indicators} language={language} />
      </Col>
    </Col>
  );
}

export default TeamMember;
